import { useEffect } from 'react';
import { IMAGE_SERVICE_URL } from '../../../util/ImageService';

const ImageUploadTestRedirect = () => {
    useEffect(() => {
        window.location.href = `${IMAGE_SERVICE_URL}/imageUploadTest`;
    }, []);

    return (
        <div style={{ padding: '48px 16px', textAlign: 'center' }}>
            이미지 업로드 테스트 페이지로 이동 중...
        </div>
    );
};

export default ImageUploadTestRedirect;
